import { Link } from '@tanstack/react-router';

export function CookiesPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-display font-bold text-white mb-2">How We Use Cookies</h1>
      <p className="text-dream-400 text-sm mb-8">Last Updated: 8/22/24</p>

      <div className="card space-y-6">
        <p className="text-dream-300">
          At DreamPaths, we use cookies and similar technologies to enhance your experience on our website
          and mobile app. This page explains how we use cookies, what they do, and your options regarding
          their use.
        </p>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">What are cookies?</h2>
          <p className="text-dream-300">
            Cookies are small text files that are placed on your device when you visit a website or use an
            app. They help us identify users and remember certain information about your visit.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">How DreamPaths uses cookies</h2>
          <div className="space-y-3">
            <p className="text-dream-300">We use cookies for the following purposes:</p>
            <p className="text-dream-300">
              <strong className="text-dream-200">Essential functionality:</strong> Cookies are required for
              our website and app to function properly. They enable core features such as user
              authentication and remembering your cookie preferences.
            </p>
            <p className="text-dream-300">
              <strong className="text-dream-200">User identification:</strong> We use cookies to identify
              users on our website and mobile app.
            </p>
            <p className="text-dream-300">
              <strong className="text-dream-200">Analytics:</strong> We use Google Analytics to understand
              how visitors use our site and to improve our services.
            </p>
            <p className="text-dream-300">
              <strong className="text-dream-200">Advertising:</strong> We use Meta Pixel (formerly Facebook
              Pixel) to potentially deliver advertisements for the DreamPaths community via their
              advertising networks in the future.
            </p>
            <p className="text-dream-300">
              <strong className="text-dream-200">Security:</strong> We use Cloudflare for DNS proxy and
              security protection, which may involve the use of cookies.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">Cookie duration</h2>
          <p className="text-dream-300">Our cookies are stored for 30 days.</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">Personal information</h2>
          <p className="text-dream-300">Our cookies do not contain any personal information.</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">Third-party cookies</h2>
          <p className="text-dream-300">
            We use services from Google Analytics, Meta (Facebook), and Cloudflare, which may set their own
            cookies. Please refer to their respective privacy policies for more information on how they use
            cookies.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">Legal information</h2>
          <p className="text-dream-300">
            DreamPaths is owned by Authentic Creative, LLC, a Delaware company, and operates primarily in the
            United States. For more information about how we handle your data, please refer to our{' '}
            <Link to="/privacy" className="text-dream-200 underline hover:text-white">
              Privacy Policy
            </Link>
            .
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">Updates to this policy</h2>
          <p className="text-dream-300">
            We may update this cookie policy from time to time. Please check this page regularly for any
            changes. By continuing to use our website and app, you consent to our use of cookies as described
            in this policy. If you have any questions about our use of cookies, please{' '}
            <a href="mailto:support@dreampaths.com" className="text-dream-200 underline hover:text-white">
              contact us
            </a>
            .
          </p>
        </section>
      </div>
    </div>
  );
}
